<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    children: Snippet;
    class?: string;
    bg?: string;
    borderColor?: string;
    cornerColor?: string;
    cornerSize?: number | 'auto';
    cornerStroke?: number;
    borderWidth?: number;
  }

  let {
    children,
    class: className = '',
    bg = 'bg-white/50',
    borderColor = 'rgba(101, 101, 101, 0.31)',
    cornerColor = '#020202',
    cornerSize = 'auto',
    cornerStroke,
    borderWidth = 1
  }: Props = $props();

  // Default corner stroke to match border width
  const effectiveCornerStroke = $derived(cornerStroke ?? borderWidth);

  let containerEl: HTMLDivElement;
  let computedCornerSize = $state(8);

  $effect(() => {
    if (containerEl && cornerSize === 'auto') {
      const updateSize = () => {
        const minDimension = Math.min(containerEl.offsetWidth, containerEl.offsetHeight);
        computedCornerSize = Math.round(minDimension * 0.065);
      };
      updateSize();
      const observer = new ResizeObserver(updateSize);
      observer.observe(containerEl);
      return () => observer.disconnect();
    }
  });

  const effectiveCornerSize = $derived(cornerSize === 'auto' ? computedCornerSize : cornerSize);
</script>

<div
  bind:this={containerEl}
  class="relative {bg} {className}"
  style="border: {borderWidth}px solid {borderColor};"
>
  <!-- Top Left Corner -->
  <div
    class="absolute -top-px -left-px z-10"
    style="width: {effectiveCornerSize}px; height: {effectiveCornerSize}px; border-top: {effectiveCornerStroke}px solid {cornerColor}; border-left: {effectiveCornerStroke}px solid {cornerColor};"
  ></div>

  <!-- Top Right Corner -->
  <div
    class="absolute -top-px -right-px z-10"
    style="width: {effectiveCornerSize}px; height: {effectiveCornerSize}px; border-top: {effectiveCornerStroke}px solid {cornerColor}; border-right: {effectiveCornerStroke}px solid {cornerColor};"
  ></div>

  <!-- Bottom Left Corner -->
  <div
    class="absolute -bottom-px -left-px z-10"
    style="width: {effectiveCornerSize}px; height: {effectiveCornerSize}px; border-bottom: {effectiveCornerStroke}px solid {cornerColor}; border-left: {effectiveCornerStroke}px solid {cornerColor};"
  ></div>

  <!-- Bottom Right Corner -->
  <div
    class="absolute -bottom-px -right-px z-10"
    style="width: {effectiveCornerSize}px; height: {effectiveCornerSize}px; border-bottom: {effectiveCornerStroke}px solid {cornerColor}; border-right: {effectiveCornerStroke}px solid {cornerColor};"
  ></div>

  <!-- Content -->
  {@render children()}
</div>
